import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import ProductCard from "../components/ProductCard";
import "../styles/Allproduct.css";

export default function Allproduct() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const [showFilters, setShowFilters] = useState(false); // 🔥 mobile toggle

  // Fetch products
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "products"), (snap) => {
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(data);
    });

    return () => unsub();
  }, []);

  // Fetch categories
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "categories"), (snap) => {
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(data);
    });

    return () => unsub();
  }, []);

  // Filter logic
  const filteredProducts = products.filter((p) => {
    const matchCategory =
      selectedCategory === "" ||
      String(p.categoryId) === selectedCategory;

    const matchPrice =
      maxPrice === "" || p.price <= Number(maxPrice);

    return matchCategory && matchPrice;
  });

  return (
    <div className="catalog-layout">

      {/* 🔥 MOBILE FILTER BUTTON */}
      <button
        className="filter-toggle"
        onClick={() => setShowFilters(!showFilters)}
      >
        ☰ Filters
      </button>

      {/* 🧭 SIDEBAR */}
      <div className={`sidebar ${showFilters ? "show" : ""}`}>
        <h3>Filters</h3>

        {/* Category */}
        <div className="filter-group">
          <h4>Category</h4>

          <label>
            <input
              type="radio"
              name="category"
              checked={selectedCategory === ""}
              onChange={() => setSelectedCategory("")}
            />
            All
          </label>

          {categories.map((c) => (
            <label
              key={c.id}
              className={selectedCategory === String(c.cid) ? "active-filter" : ""}
            >
              <input
                type="radio"
                name="category"
                value={c.cid}
                checked={selectedCategory === String(c.cid)}
                onChange={(e) => setSelectedCategory(e.target.value)}
              />
              {c.name}
            </label>
          ))}
        </div>

        {/* Price */}
        <div className="filter-group">
          <h4>Price</h4>

          {["", "500", "1000", "2000"].map((price) => (
            <label key={price}>
              <input
                type="radio"
                name="price"
                value={price}
                checked={maxPrice === price}
                onChange={(e) => setMaxPrice(e.target.value)}
              />
              {price === "" ? "All" : `Below ₹${price}`}
            </label>
          ))}
        </div>
      </div>

      {/* 🛍 PRODUCTS */}
      <div className="products-section">
        <h2>All Products</h2>

        <div className="products-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))
          ) : (
            <p>No products found</p>
          )}
        </div>
      </div>

    </div>
  );
}